import { dateFnsLocaleMap } from '@griply/utils';
import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';
import { WeekDays } from 'shared/types/week-days';

Object.entries(dateFnsLocaleMap).forEach(([code, locale]) => {
  // @ts-ignore -- react-datepicker's registerLocale types predate date-fns v3 Locale
  registerLocale(code, locale);
});

const weekDaysToNumbers: Record<WeekDays, number> = {
  [WeekDays.Monday]: 1,
  [WeekDays.Tuesday]: 2,
  [WeekDays.Wednesday]: 3,
  [WeekDays.Thursday]: 4,
  [WeekDays.Friday]: 5,
  [WeekDays.Saturday]: 6,
  [WeekDays.Sunday]: 0,
};

export type ReactDatePickerProps = Omit<
  React.ComponentProps<typeof DatePicker>,
  'popperClassName' | 'calendarStartDay' | 'locale'
> & {
  className?: string;
  weekStartsOn?: WeekDays;
};

export const ReactDatePicker: React.FC<ReactDatePickerProps> = ({
  className,
  weekStartsOn,
  ...rest
}) => {
  const locale = useI18nLocale();

  return (
    <DatePicker
      popperClassName={className}
      calendarStartDay={
        weekStartsOn ? weekDaysToNumbers[weekStartsOn] : undefined
      }
      locale={locale}
      {...rest}
    />
  );
};
